<template>
  <v-container>
    <!-- <h1 class="subtitle-1 grey--text">Obras</h1> -->
    <v-row>
      <v-col cols="12">
        <v-row
          align="center"
          justify="center"
          class="grey lighten-5"
          style="height: 300px"
        >
          <div v-if="loading" class="text-center mt-5">
            <img src="img/logo_cargando.gif" alt="apa" />
            <h1 class="title">Cargando . . .</h1>
          </div>

          <p class="ma-2 pa-2" v-if="ordenesPago.length == 0 && !loading">
            Tus obras aún no generaron regalías desde que fueron declaradas en
            APA y subidas al sistema. Podrías solicitar más información en:
            informes_distribucion@apa.org.py o llamando al 021-445-300.
          </p>

          <v-container class="my-5" v-if="!loading">
            <v-card class="pa-3" flat>
              <v-row row v-for="op in ordenesPago" :key="op.id"  align="center" >
                <v-col cols="12" sm="4">
                  <div class="caption grey--text">Liquidacion</div>
                  <div>{{ op.generacion.descripcion }}</div>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-row>

                    <LiquidacionResumen
                      :liquidacion_id="op.liquidacion.id"
                      :op="op"
                    />
                  <Confirmar
                    boton=""
                    titulo="Descargar"
                    texto="¿Te gustaría descargar el resumen en formato PDF?"
                    icon="save_alt"
                    small
                    :loading="downloading"
                    @si="descargarResumen(op.id)"
                  />
                  </v-row>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </v-card>
          </v-container>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import numeral from "numeral";
import format from "date-fns/format";
import LiquidacionResumen from "@/components/LiquidacionResumen";
import { saveAs } from "file-saver";
import Confirmar from "@/components/Confirmar";

export default {
  data() {
    return {
      ordenesPago: [],
      loading: false,
      downloading: false,
    };
  },
  mounted() {
    this.loading = true;
    axios
      .get("/miapa/ordenpago")
      .then((response) => {
        this.loading = false;
        this.ordenesPago = response.data.filter((op) => op.estado == "Valido");
      })
      .catch((error) => {
        this.loading = false;
        console.log(error);
      });
  },
  methods: {
    // saldoOP(op) {
    //   return op.monto - op.pagosDetalle.reduce((a, b) => a + b.monto, 0);
    //   //return op.monto - 10;
    // }

    descargarResumen(id) {
      this.downloading = true;
      axios
        .get("/report/ordenpago/resumen/" + id)
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
          this.downloading = false;
          this.$store.dispatch("showSnack", "Descargando..!");
        })
        .catch((err) => {
          this.downloading = false;
          console.log(err);
          this.errorMessage = "Error en la consulta";
          this.$store.dispatch("showSnack", "Error");
        });
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
  },
  filters: {
    // numberToHHMM(value) {
    //   if (value) {
    //     return value ? format(new Date(value), "hh:mm") : "";
    //   }
    // },
    numberFormat(value) {
      if (value) {
        return numeral(value).format("#,##0"); // displaying other groupings/separators is possible, look at the docs
      }
    },
    dateFormat(value) {
      return value ? format(new Date(value), "dd/MM/YYY") : "";
    },
  },
  components: {
    LiquidacionResumen,
    Confirmar,
  },
};
</script>

<style scoped>
#chip.Valido {
  background: lightgreen;
}

#chip.Anulado {
  background: lightcoral;
}

#chip.Retenido {
  background: lightcoral;
}

#chip.Reservado {
  background: lightcoral;
}
</style>
